import React, { useState } from 'react'
import { Button, CardBody, Col, Input, Label, Row } from 'reactstrap';
import { Category, Description, Featured, Image, ItemName, MaxOrder, MinOrder, Next, Point, PurchasePrice, Quantity, RewardPoint, SalesPrice, ShippingCharge, sku, Tax, Web, Weight, Weigth } from '../../../../Constant';
import { Controller } from 'react-hook-form';
import Typeahead from '../../../../CommonElements/TypeAhead';

const ItemForm = ({ register, control, errors,trigger, setNextTab, taxOption, categoryOption, apiImage, getValues }) => {
    const [image, setImage] = useState(null);
    const [error, setError] = useState({ minOrder: '', maxOrder: '' });

    const handleLogoChange = (event) => {
        const selectedFile = event.target.files[0];
        setImage(selectedFile);
    }

    const handleNavigateNext = async () => {
        const isValid = await trigger()
        if (isValid) {
            setNextTab("2")
        }
    }
    return (
        <CardBody>
            <Row className="g-3 pt-3">
                <Col md='6'>
                    <Label className="form-label" for="name">{ItemName} <span className="requireStar">*</span></Label>
                    <input className="form-control" id="name" type="text"
                        {...register('itemName')}
                    />
                    <p className="text-danger">{errors.itemName?.message}</p>
                </Col>
                <Col md='6'>
                    <Label className="form-label" for="sku">{sku} <span className="requireStar">*</span></Label>
                    <input className="form-control" id="sku" type="text"
                        {...register('sku')}
                    />
                    <p className="text-danger">{errors.sku?.message}</p>
                </Col>
            </Row>
            <Row className="g-3 pt-3">
                <Col md='6'>
                    <Label className="form-label" for="sales_price">{SalesPrice} <span className="requireStar">*</span></Label>
                    <input className="form-control" id="sales_price" type="number" min="0"
                        {...register('sales_price')}
                    />
                    <p className="text-danger">{errors.sales_price?.message}</p>
                </Col>
                <Col md='6'>
                    <Label className="form-label" for="purchase_price">{PurchasePrice} <span className="requireStar">*</span></Label>
                    <input className="form-control" id="purchase_price" type="number" min="0"
                        {...register('purchase_price')}
                    />
                    <p className="text-danger">{errors.purchase_price?.message}</p>
                </Col>
            </Row>
            <Row className="g-3 pt-3">
                <Col md="6">
                    <Label className="form-label" >{Tax}</Label>
                    <Controller
                        name="tax"
                        control={control}
                        render={({ field }) => (
                            <Typeahead
                                options={taxOption}
                                onChange={(value) => {
                                    field.onChange(value);
                                }}
                                value={field.value}
                            />
                        )}
                    />
                    <p className="text-danger">{errors.tax?.message}</p>
                </Col>
                <Col md='6'>
                    <Label className="form-label" for="qty">{Quantity} <span className="requireStar">*</span></Label>
                    <input className="form-control" id="qty" type="number" min="0"
                        {...register('quantity')}
                    />
                    <p className="text-danger">{errors.quantity?.message}</p>
                </Col>
            </Row>
            <Row className="g-3 pt-3">
                <Col md="6">
                    <Label className="form-label" >{Category} <span className="requireStar">*</span></Label>
                    <Controller
                        name="category"
                        control={control}
                        render={({ field }) => (
                            <Typeahead
                                options={categoryOption}
                                onChange={(value) => {
                                    field.onChange(value);
                                }}
                                value={field.value}
                            />
                        )}
                    />
                    <p className="text-danger">{errors.category?.message}</p>
                </Col>
                <Col md='6'>
                    <Label className="form-label" for="weight">{Weight}</Label>
                    <input className="form-control" id="weight" type="number" min="0"
                        {...register('weight')}
                    />
                </Col>
            </Row>
            <Row className="g-3 pt-3">
                <Col md='6'>
                    <Label className="form-label" for="qty">{MinOrder} <span className="requireStar">*</span></Label>
                    <input className="form-control" id="qty" type="number" min="0" {...register('minOrder')}
                        // onChange={(e) => {
                        //     const value = e.target.value;
                        //     const { maxOrder: max } = getValues();
                        //     const newErrors = { minOrder: '', maxOrder: '' };

                        //     if (value && !max) {
                        //         newErrors.maxOrder = 'Maximum order is required';
                        //     } else if (value && max && Number(value) >= Number(max)) {
                        //         newErrors.minOrder = 'Minimum must be less than maximum';
                        //         newErrors.maxOrder = 'Maximum must be greater than minimum';
                        //     }
                        //     setError(newErrors);
                        // }}
                    />
                    {error?.minOrder ? <p className="text-danger">{error.minOrder}</p> : <p className="text-danger">{errors.minOrder?.message}</p>}
                </Col>
                <Col md='6'>
                    <Label className="form-label" for="qty">{MaxOrder} <span className="requireStar">*</span></Label>
                    <input className="form-control" id="qty" type="number" min="0" {...register('maxOrder')}
                        // onChange={(e) => {
                        //     const value = e.target.value;
                        //     const { minOrder: min } = getValues();
                        //     const newErrors = { minOrder: '', maxOrder: '' };

                        //     if (value && !min) {
                        //         newErrors.minOrder = 'Minimum order is required';
                        //     } else if (min && value && Number(min) >= Number(value)) {
                        //         newErrors.minOrder = 'Minimum must be less than maximum';
                        //         newErrors.maxOrder = 'Maximum must be greater than minimum';
                        //     }
                        //     setError(newErrors);
                        // }}
                    />
                    {error.maxOrder ? <p className="text-danger">{error.maxOrder}</p> : <p className="text-danger">{errors.maxOrder?.message}</p>}
                </Col>
            </Row>
            <Row className="g-3 pt-3">
                <Col md='6'>
                    <Label className="form-label" for="qty">{RewardPoint} <span className="requireStar">*</span></Label>
                    <input className="form-control" id="qty" type="number" min="0"
                        {...register('point')}
                    />
                    <p className="text-danger">{errors.point?.message}</p>
                </Col>
                <Col md="6">
                    <Label className="form-label">{Image}</Label>
                    <Controller
                        name="image"
                        control={control}
                        render={({ field }) => (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Col md="8">
                                    <input
                                        {...register("image")}
                                        className="form-control fileInputStyle"
                                        type="file"
                                        onChange={handleLogoChange}
                                        accept=".png, .jpg, .jpeg"
                                    />
                                </Col>
                                <Col md='4'>
                                    <span className="imagestyle">
                                        {image == null ?
                                            apiImage && <img src={apiImage} alt="image" width="40px" height="40px" />
                                            :
                                            <img src={URL.createObjectURL(image)} alt="image" width="40px" height="40px" />
                                        }
                                    </span>
                                </Col>
                            </div>
                        )}
                    />
                    <span className="text-danger">{errors.logo && "logo is required"}</span>
                </Col>
            </Row>
            <Row className="g-3 pt-3">
                <Col>
                    <Label for="chk-ani">
                        <Controller
                            name="isFeatured"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                                <Input
                                    type="checkbox"
                                    id="chk-ani"
                                    className="checkbox_animated"
                                    checked={field.value === 1}
                                    onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                />
                            )}
                        />
                        {Featured}
                    </Label>

                    <Label style={{ paddingLeft: '40px' }} for="chk-ani1">
                        <Controller
                            name="isWeb"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                                <Input
                                    type="checkbox"
                                    id="chk-ani1"
                                    className="checkbox_animated"
                                    checked={field.value === 1}
                                    onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                />
                            )}
                        />
                        {Web}
                    </Label>

                    <Label style={{ paddingLeft: '40px' }} for="chk-ani2">
                        <Controller
                            name="isShip"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                                <Input
                                    type="checkbox"
                                    id="chk-ani2"
                                    className="checkbox_animated"
                                    checked={field.value === 1}
                                    onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                />
                            )}
                        />
                        {ShippingCharge}
                    </Label>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Label className="form-label pt-3">{Description}</Label>
                    <Controller
                        name="description"
                        control={control}
                        render={({ field }) => (
                            <textarea
                                className="form-control"
                                {...field}
                                rows="3"
                                maxLength={1000}
                            />
                        )}
                    />
                </Col>
            </Row>
            <Row className="g-3 pt-3">
                <div className="text-end  ">
                    <Button className="tab-button" onClick={() => handleNavigateNext()}>{Next}</Button>
                </div>
            </Row>
        </CardBody>

    )
}

export default ItemForm